<template>
  <section class="aggregator-order">
    <article
      class="aggregator-order__card"
      v-for="appointment in list"
      v-bind:key="appointment.id"
    >
      <div class="aggregator-order__row">
        <span class="aggregator-order__date">{{ appointment.starts_date }}</span>
        <span class="aggregator-order__time">{{ appointment.starts_time }}</span>
      </div>
      <div class="aggregator-order__row">
        <span class="aggregator-order__term">Врач</span>
        <span class="aggregator-order__def">{{ appointment.employee.name }}</span>
      </div>
      <div class="aggregator-order__row">
        <span class="aggregator-order__term">Пациент</span>
        <span class="aggregator-order__def">{{ appointment.patient_name }}</span>
      </div>
      <div
        class="aggregator-order__row"
        v-if="appointment.guardian_name.length > 0"
      >
        <span class="aggregator-order__term">Представитель</span>
        <span class="aggregator-order__def">{{ appointment.guardian_name }}</span>
      </div>
      <div class="aggregator-order__row">
        <span class="aggregator-order__term">Телефон</span>
        <span
          class="aggregator-order__def">{{ appointment.phone }}
        </span>
        <div class="aggregator-order__actions">
          <the-tooltip v-if="canInitiateCall && appointment.no_call" position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="aggregator-order__action aggregator-order__action--phone"
                type="button"
                v-on="listenerObject" />
            </template>
            Пациент отказался от звонков
          </the-tooltip>
          <button
            v-else-if="canInitiateCall"
            class="aggregator-order__action aggregator-order__action--phone"
            title="Начать звонок"
            type="button"
            v-on:click="onInitiateCall(appointment)"
          />
          <the-tooltip v-if="appointment.has_whats_app && !appointment.agree_mailing" position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="aggregator-order__action aggregator-order__action--whats-app"
                type="button"
                v-on="listenerObject" />
            </template>
            Пациент отказался от рассылок
          </the-tooltip>
          <button
            v-else-if="appointment.has_whats_app"
            class="aggregator-order__action aggregator-order__action--whats-app"
            title="Открыть чат"
            type="button"
            v-on:click="onOpenWhatsAppChat(appointment)"
          />
          <the-tooltip v-if="messengersAccess && !appointment.agree_mailing" position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="aggregator-order__action aggregator-order__action--chat-push"
                type="button"
                v-on="listenerObject" />
            </template>
            Пациент отказался от рассылок
          </the-tooltip>
          <button
            v-else-if="messengersAccess"
            class="aggregator-order__action aggregator-order__action--chat-push"
            title="Открыть чат"
            type="button"
            v-on:click="onOpenMessengersChat(appointment)"
          />
        </div>
      </div>
      <div class="aggregator-order__row">
        <span class="aggregator-order__def">
          {{appointment.calling_note}}
        </span>
      </div>
      <div class="aggregator-order__buttons">
        <button
          class="aggregator-order__make"
          type="button"
          v-on:click="dispatchConfirm(appointment.id)">Подтвердить</button>
        <button
          class="aggregator-order__make"
          type="button"
          v-on:click="onEditAppointment(appointment)">
          Редактировать
        </button>
      </div>
    </article>
  </section>
</template>

<script>
import { EventBus, NAME_EVENT_OPEN_MESSENGERS_CHAT, NAME_EVENT_OPEN_WHATS_APP_CHAT } from '@/utils/eventBus';
import TheTooltip from '@/components/TheTooltip.vue';

/**
 * @description Действие инициировать звонки.
 * @type {string}
 */
const ACTION_INITIATE_CALLS = 'initiate-calls';

/**
 * @description Название события инициации звонка.
 * @type {string}
 */
const NAME_EVENT_INITIATE_CALL = 'initiate-call';

/**
 * @description Название редактирования записи на прием.
 * @type {string}
 */
const NAME_EVENT_EDIT_APPOINTMENT = 'edit-appointment';

export default {
  components: { TheTooltip },
  computed: {
    canInitiateCall() {
      return this.actions.includes(ACTION_INITIATE_CALLS);
    },
    /**
     * @description Доступ к мессенджерам.
     * @returns {boolean}
     */
    messengersAccess() {
      return this.$store.getters.getAvailableSections.includes('messengers');
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    /**
     * @description Обработать открытие Whats App чата.
     * @param {Object} appointment
     * @returns {void}
     */
    onOpenWhatsAppChat(appointment) {
      const phoneWithoutDelimiters = appointment.phone.replace(/[-+() ]/g, '');
      EventBus.$emit(NAME_EVENT_OPEN_WHATS_APP_CHAT, phoneWithoutDelimiters);
    },
    /**
     * @description Обработать открытие чата Мессенджеров.
     * @param {Object} appointment
     * @returns {void}
     */
    onOpenMessengersChat(appointment) {
      const phoneWithoutDelimiters = appointment.phone.replace(/[-+() ]/g, '');
      EventBus.$emit(NAME_EVENT_OPEN_MESSENGERS_CHAT, phoneWithoutDelimiters);
    },
    /**
     * @description Обработать инициацию звонка.
     * @param {Object} appointment
     * @returns {void}
     */
    onInitiateCall(appointment) {
      this.$emit(NAME_EVENT_INITIATE_CALL, appointment.patient_id, appointment.phone);
    },
    /**
     * @description Отправить событие создания.
     * @param {number} id Идентификатор заявки.
     * @returns {void}
     */
    dispatchConfirm(id) {
      this.$emit('confirm-appointment', id);
    },
    onEditAppointment(appointment) {
      this.$emit('close');
      this.$emit(
        NAME_EVENT_EDIT_APPOINTMENT,
        Number(appointment.id),
        appointment.date,
        appointment.employee,
      );
    },
  },
  props: {
    /**
     * @description Действия.
     */
    actions: { required: true, type: Array },
    /**
     * @description Ближайшие неподтвержденные заявки на прием.
     */
    list: { type: Array, required: true },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.aggregator-order {
  &__caption {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    margin: 10px 0;
    cursor: pointer;
    color: #0489e0;
    border-bottom: 1px dashed;
    &:hover {
      border-bottom: 1px dashed transparent;
    }
  }
  &__card {
    display: flex;
    flex-direction: column;
    background-color: #ffeded;
    border: 1px solid rgba(239, 71, 76, 0.4);
    border-right: 6px solid #EF474C;
    border-radius: 4px;
    padding: 9px 11px;
    margin: 0 0 3px 0;
  }
  &__date,
  &__time,
  &__term {
    color: #707683;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  &__row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  &__actions {
    display: inline-flex;
    align-items: center;
    column-gap: 10px;
    width: fit-content;
    margin-left: 14px;
  }
  &__action {
    width: 20px;
    height: 20px;;
    margin-right: auto;
    background-size: contain;
    background-position: center;
    &:hover {
      filter: brightness(95%) contrast(85%);
    }
    &--phone {
      background-image: url('@/assets/img/phone-blue.svg');
    }
    &--whats-app {
      width: 21px;
      height: 21px;
      background-image: url('@/assets/img/social/whatsapp-brand-green.svg');
    }
    &--chat-push {
      width: 25px;
      height: 25px;
      background-image: url('@/assets/img/chat.svg');
    }
  }
  &__def {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #192A3E;
    &.callable {
      color: var(--action-color);
      text-decoration: underline;
    }
  }
  &__term ~ &__def,
  &__date ~ &__time {
    margin-left: 1rem;
  }
  &__term:after {
    content: ":";
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 15px 0 0 0;
  }
  &__cancel {
    @include buttons.btn-transparent(100%, 2rem, 1rem);
    &.modal {
      max-width: 50%;
      margin: 0 5px;
    }
    &.negative {
      border: 1px solid rgba(224, 4, 4, 0.97);
      color: rgba(224, 4, 4, 0.97);
    }
  }
  &__make {
    @include buttons.btn-blue(100%, 2rem, 1rem);
  }
}
</style>
